module["exports"] = [
  "###-########",
  "####-########",
  "###########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/phone_number/formats.js
// module id = 1819
// module chunks = 0